import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/security/app-properties'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        updateBrand(context, { data, config }) {
            return base.request.put(`${baseUrl}/brand`, data, { ...config })
        },
        updateLogo(context, { data, config }) {
            return base.request.put(`${baseUrl}/logo`, data, { ...config })
        },
        updateFavicon(context, { data, config }) {
            return base.request.put(`${baseUrl}/favicon`, data, { ...config })
        },
        testEmail(context, { data, config }) {
            return base.request.post(`${baseUrl}/test-email`, data, { ...config })
        },
    },
    mutations: {
        ...base.mutations
    },
}
